import React from 'react';
import Sidenavigation1 from '../../layouts/Sidenavigation1';
import Topnavigation from '../../layouts/Topnavigation';

import { TheMasterContextProvider } from '../../MyContexts/Master_Context';
import ImageGallContent from './ImageGallContent';

const ImageGall = (props) => {
    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar">
            <TheMasterContextProvider>
               
                    <Sidenavigation1 />
                    <main className="body-content">
                        <Topnavigation />
                        <ImageGallContent />
                    </main>
               
            </TheMasterContextProvider>
        </div>
    );
}

export default ImageGall;